import axios from "../axiosInstance";
import { listarSolicitantes } from "../shared/utils/Endpoints"
class SolicitanteService {
    async listarSolicitantes(nomeOuRegistro, ufConselho) {
        var teste = await axios.get(listarSolicitantes, {
            params: {
                nomeOuCodigo: nomeOuRegistro,
                ufConselho: ufConselho
            }
        });
        return teste;
    };
}

export default new SolicitanteService();